import { render, staticRenderFns } from "./mailbox-nav-bar.vue?vue&type=template&id=71ef6f03&scoped=true&"
import script from "./mailbox-nav-bar.vue?vue&type=script&lang=js&"
export * from "./mailbox-nav-bar.vue?vue&type=script&lang=js&"
import style0 from "./mailbox-nav-bar.vue?vue&type=style&index=0&id=71ef6f03&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71ef6f03",
  null
  
)

export default component.exports